<template>
  <div class="order_list">
    <el-form :inline="true" :model="search" class="demo-form-inline" size="small">
      <el-form-item label="订单号">
        <el-input v-model="search.tradeno" placeholder="订单编号"></el-input>
      </el-form-item>
      <el-form-item label="采购人">
        <el-input v-model="search.buyer" placeholder="采购人电话号码"></el-input>
      </el-form-item>
      <el-form-item label="商品ID">
        <el-input v-model="search.goods" placeholder="商品ID"></el-input>
      </el-form-item>
      <el-form-item label="下单时间">
        <el-date-picker
          v-model="search.ordertime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" border size="mini">
      <el-table-column prop="tradeno" label="订单编号" width="100" fixed="left"></el-table-column>
      <el-table-column
        prop="title"
        label="商品标题">
      </el-table-column>
      <el-table-column
        prop="specification"
        label="产品规格">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="购买数量">
      </el-table-column>
      <el-table-column
        prop="buyer"
        label="采购人">
      </el-table-column>
      <el-table-column
        prop="create_time"
        label="下单时间">
      </el-table-column>
      <el-table-column
        prop="mark"
        label="备注">
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="150">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleMark(scope.$index, scope.row)">备注</el-button>
          <el-button size="mini" type="success" plain @click="handleInfo(scope.$index, scope.row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="订单详情"
      :visible.sync="dialogInfoVisible"
      width="30%"
      top="10vh"
      :before-close="handleInfoClose">
        <el-row class="info-row">
          <el-col>订单编号：</el-col>
          <el-col>产品标题：</el-col>
          <el-col>产品规格：</el-col>
          <el-col>购买数量：</el-col>
          <el-col>采购人：</el-col>
          <el-col>下单时间：</el-col>
          <el-col>收货人：</el-col>
          <el-col>联系电话：</el-col>
          <el-col>收货地址：</el-col>
          <el-col>备注：</el-col>
        </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogInfoVisible = false" size="mini">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加备注"
      :visible.sync="dialogMarkVisible"
      width="30%"
      :before-close="handleMarkClose">
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入备注"
        v-model="mark">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogMarkVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogMarkVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'Order_list',
  data () {
    return {
      mark: '',
      dialogMarkVisible: false,
      dialogInfoVisible: false,
      search: {},
      tableData: [{}]
    }
  },
  methods: {
    handleMark () {
      this.dialogMarkVisible = true
      console.log('mark')
    },
    handleMarkClose () {
      console.log('markclose')
    },
    handleInfo () {
      this.dialogInfoVisible = true
    },
    handleInfoClose () {
      this.dialogInfoVisible = false
      console.log('handleInfoClose')
    },
    onSearch () {
      console.log('search')
    }
  }
}
</script>

<style scoped>
.info-row div{
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #e9e9e9;
}
</style>
